import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import { DataContext } from 'providers/data';
import { ParamsPaymentForms, ParamsPageWebView } from 'utils/typeServices';

import { Box, Typography, Radio, Skeleton } from '@mui/material';

import Modals from 'components/views/Modals';
import ParseWebView from 'components/views/ParseWebView';
import FadeAnimation from 'components/views/FadeAnimation';
import PhoneCopyWebView from 'components/views/PhoneCopyWebView';
import ShoppingCart from 'components/views/AdditionalServices/ShoppingCart';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import { Step, StepLabel, Stepper, ContentShopping, LinkExtermal } from '../ServicesList/styles';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { ReactComponent as IcIturinCoverage } from 'assets/icons/ic-iturin-coverage.svg';

const styleTittle = {
    fontWeight: 700,
    fontSize: { xs: '1rem', md: '1.125rem' },
    textTransform: 'uppercase',
}

const styleCase = {
    fontWeight: 700,
    fontSize: { xs: '1.125rem', md: '1.25rem' },
    textAlign: 'center',
    borderRadius: '.4rem',
    color: 'primary.light',
    border: '1px solid #17A7E0',
    padding: { xs: '.5rem 0 .18rem', md: '.5rem 1.3rem .18rem' },
}

const steps: Array<string> = [
    'Serviços adicionais',
    'Pagamento',
    'Conclusão'
];

const Payment = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [itemSelectedState, setItemSelectedState] = useState<ParamsPaymentForms>();
    const [showModalConfirm, setShowModalConfirm] = useState(false);
    const { dataCreateOrder, selectedCar, customerCars, customerPaymentForms, dataListQuoteAdd, dataProductCartAddServices, isPendingTicket, dataGetListarCotacoesAddService, handleGetPaymentForms, handleGetBillingsByCustomerId, handlePostCreateOrderAddServices, handleParseProductCartAddServices, handleSelectedCar } = useContext(DataContext);

    const handlePostCreateOrderAddServicesState = () => {
        setIsLoading(true);
        const listProductOrder = dataProductCartAddServices.productAdd.map(({ cD_COTACAO_ITEM }) => {
            return { TIPO_COBRANCA_DESCONTO: [], CD_COTACAO_ITEM: cD_COTACAO_ITEM, VL_COMISSAO: 0 }
        });

        if (dataListQuoteAdd && listProductOrder && itemSelectedState) {
            handlePostCreateOrderAddServices({
                PRODUTO_ITEM_ESCOLHIDOS: listProductOrder,
                FORMA_PAGAMENTO_COBRANCAS: [],
                FL_DOMICILIAR: false,
                FL_PROCESS_URA: false,
                SISTEMA_ENUM: 16,
                SOMENTE_LINK_EMAIL: true,
                GUID_COTACAO: dataListQuoteAdd.GUID_COTACAO,
                CD_CANAL_VENDA: dataListQuoteAdd.CD_CANAL_VENDA,
                CD_PESSOA_PARCEIRO: dataListQuoteAdd.CD_PESSOA_PARCEIRO,
                CD_PESSOA_PARCEIRO_ESTABELECIMENTO: dataListQuoteAdd.CD_PESSOA_PARCEIRO_ESTABELECIMENTO
            },
                isWebView
            );
        }

    }

    useEffect(() => {
        if (!customerPaymentForms) {
            handleGetPaymentForms({ token: localStorage.getItem('token')! });
        }

        if (customerPaymentForms && selectedCar) {
            const customerPaymentFormsSelected = customerPaymentForms.find(({ Id }) => selectedCar.NR_PLATAFORMA === Id);
            customerPaymentFormsSelected && setItemSelectedState(customerPaymentFormsSelected);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerPaymentForms]);

    useEffect(() => {
        if ((typeof isPendingTicket === "undefined") || (customerCars?.length > 1)) {
            handleGetBillingsByCustomerId({ token: localStorage.getItem('token')! });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPendingTicket, customerCars]);

    useEffect(() => {
        if (dataCreateOrder === false) {
            setIsLoading(false);
            setShowModalConfirm(false);
            setShowModalError(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCreateOrder]);

    const handleParseProductCartAddServicesState = () => {
        if (dataGetListarCotacoesAddService?.quoteItemsChooses && selectedCar) {
            handleParseProductCartAddServices({
                body: {
                    cD_COTACAO: dataGetListarCotacoesAddService.quote.cD_COTACAO,
                    cD_PEDIDO: state.cD_PEDIDO,
                    customerId: selectedCar.CD_PESSOA,
                    quoteItemsChooses: dataGetListarCotacoesAddService?.quoteItemsChooses
                }
            });
        }
    }

    useEffect(() => {
        if (state?.isExchangesInProgress) {
            handleParseProductCartAddServicesState();

            const carSelected = customerCars.find(({ CD_PEDIDO }) => CD_PEDIDO === state.cD_PEDIDO);

            if (carSelected) {
                handleSelectedCar(carSelected);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    return (
        <ParseWebView isWebView={isWebView} typePage='page'>
            <Box sx={{ position: 'relative', borderTop: { xs: 'none', md: '1px solid rgba(141, 155, 181, 0.5)' }, paddingRight: { xs: '0', md: '2rem' }, width: { xs: '100%', md: '70%' } }}>
                {isPendingTicket ?
                    <>
                        <Box sx={{ textAlign: 'center', 'svg': { maxHeight: '114px' }, position: { xs: 'relative', md: 'absolute' }, top: 0, right: 0, left: 0, bottom: 0, height: 'fit-content', margin: 'auto' }}>
                            <IcIturinCoverage />
                            <Typography lineHeight='20px' sx={{
                                fontSize: { xs: '1rem', md: '1.25rem' },
                                lineHeight: '1.2'
                            }}>
                                Para prosseguir <b>você precisa</b> realizar o <br />
                                pagamento do(s) boleto(s) em aberto.
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: { xs: '1rem', md: '1.25rem' },
                                    paddingTop: { xs: '.68rem', md: '1.125rem' }
                                }}>
                                {isWebView ?
                                    <>Acesse suas <b>faturas</b> através do menu <br /> inferior do app.</>
                                    :
                                    <>
                                        Deseja pagar agora?&nbsp;
                                        <Link
                                            to="/faturas"
                                            style={{ color: '#17A7E0', textDecoration: 'underline', fontWeight: 700 }}
                                        >
                                            clique aqui.
                                        </Link>
                                    </>
                                }
                            </Typography>
                            <Typography sx={{
                                fontSize: { xs: '1rem', md: '1.25rem' },
                                paddingTop: { xs: '2rem', md: '2.93rem' }
                            }}>
                                Ou se preferir entre em contato:
                            </Typography>

                            <Box sx={{ width: '100%', maxWidth: '20rem', margin: '1.25rem auto 0', 'button': { width: '100%', marginBottom: '.93rem' } }}>
                                <Typography fontSize='.75rem' fontWeight={700} marginBottom='.5rem'>
                                    Digite a opção 1
                                </Typography>
                                {isWebView ?
                                    <Typography fontSize='.92rem' color='primary.main' paddingBottom='.5rem' textAlign='center'>
                                        Fale Conosco - <b>(11) 3616-9000</b>
                                    </Typography>
                                    :
                                    <ButtonRectangle name='WHATSAPP' onClick={() => { window.open('https://api.whatsapp.com/send/?phone=551136169000', '_target') }} />
                                }
                                {!isWebView &&
                                    <ButtonOutlined name='CENTRAL DE ATENDIMENTO' onClick={() => { window.open('tel:1136169000', '_target') }} />
                                }
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: { xs: '1rem 0 .75rem', md: '2rem 0 .75rem' } }}>
                                <Typography fontSize='1rem' color='white' fontWeight={700} padding='9px 2.125rem 4px' sx={{ backgroundColor: 'primary.light', width: 'fit-content', marginBottom: '5px' }}>
                                    IMPORTANTE:
                                </Typography>
                                <Typography lineHeight='19px' textAlign='center' sx={{ width: { xs: 'fit-content', md: '405px' }, border: '1.4px solid #17A7E0', borderRadius: '5px', padding: { xs: '.875rem 0', md: '.875rem .75rem .75rem' }, fontSize: { xs: '.875rem', md: '1rem' } }}>
                                    Não se preocupe, as informações do seu processo de compra ficam armazenadas.
                                    Volte quando quiser e continue de onde parou.
                                </Typography>
                            </Box>
                            <Link to='' style={{ color: '#0C1C33', textDecoration: 'underline', fontWeight: 700 }} onClick={() => setIsOpenModal(true)} >
                                SAIR
                            </Link>
                        </Box>
                    </>
                    :
                    <>
                        <Box sx={{ display: { xs: 'none', md: 'block' }, 'button': { maxWidth: '7.5rem', height: '2.18rem', position: 'absolute', top: '-1.1rem', backgroundColor: 'white', '&:hover': { backgroundColor: 'white' } } }}>
                            <ButtonOutlined name='Voltar' onClick={() => navigate(`${isWebView ? '/wb' : ''}/servicos-adicionais/servicos`)} />
                        </Box>
                        <Box sx={{
                            width: '100%',
                            display: 'flex',
                            margin: { xs: '0 0 1rem', md: '1.54rem 0 1.4rem' },
                            paddingBottom: '.75rem',
                            justifyContent: 'center'
                        }}>
                            <Stepper activeStep={1} alternativeLabel>
                                {steps.map((label, index) => (
                                    <Step key={index}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: '0', md: '1.4rem' }, alignItems: { xs: 'flex-start', md: 'flex-end' }, justifyContent: 'center', backgroundColor: 'primary.light', padding: '.6rem 1.2rem .5rem', marginBottom: '1.49rem' }}>
                            <Box sx={{ display: 'flex', alignItems: { xs: 'flex-start', md: 'flex-end' }, flexDirection: { xs: 'column', md: 'row' } }}>
                                <Typography sx={{ fontWeight: 600, fontSize: '.7rem', marginRight: '.5rem', paddingBottom: { xs: '.3rem', md: '0' } }}>
                                    Veículo:
                                </Typography>
                                <Typography variant='subtitle2'>
                                    <strong>Placa: </strong>
                                    {dataListQuoteAdd && dataListQuoteAdd.DS_PLACA}
                                </Typography>
                            </Box>
                            <Box sx={{ width: '1px', height: '1rem', backgroundColor: 'white', display: { xs: 'none', md: 'flex' } }} />
                            <Typography variant='subtitle2'>
                                <strong>Modelo: </strong>
                                {dataListQuoteAdd && dataListQuoteAdd.NM_MODELO}
                            </Typography>
                        </Box>


                        <FadeAnimation>
                            <Box>
                                <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', 'button': { maxWidth: '7.5rem', height: '2.18rem', backgroundColor: 'white', '&:hover': { backgroundColor: 'white' } } }}>
                                    <ButtonOutlined name='Voltar' onClick={() => navigate(`${isWebView ? '/wb' : ''}/servicos-adicionais/servicos`)} />
                                    <Box sx={{ width: 'calc(100% - 7.5rem)', backgroundColor: 'rgba(141, 155, 181, 0.50)', height: '1px' }} />
                                </Box>
                                <Box sx={{ backgroundColor: { xs: 'none', md: '#EFF2F5' }, padding: { xs: '1.75rem 0 2.2rem', md: '3.85rem 2.5rem 4.2rem' } }}>
                                    <Typography sx={{ fontSize: '1.125rem' }}>
                                        <b>Forma de pagamento</b> da sua contratação:
                                    </Typography>

                                    {itemSelectedState ?
                                        <Box sx={{ display: 'flex', gap: '.6rem', padding: '1rem 0 1.17rem', alignItems: 'center', 'span': { padding: '0' } }}>
                                            <Radio checked={true} name="radio-button-payment" />
                                            <Typography variant='h6' paddingTop='.3rem' fontWeight={400}>
                                                {itemSelectedState.PaymentFormTypeId === 22 ? 'Débito em conta' : 'Boleto eletrônico'}
                                            </Typography>
                                        </Box>
                                        :
                                        <Skeleton animation="wave" variant="rounded" height='2.1rem' sx={{ margin: '1rem 0 1.17rem' }} />
                                    }

                                    <Typography sx={{ fontSize: '1.125rem', paddingTop: '1.36rem', borderTop: '1px solid rgba(141, 155, 181, 0.50)' }}>
                                        Este serviço <b>será incluso</b> na sua próxima mensalidade com a <br />
                                        forma de pagamento acima.
                                    </Typography>
                                </Box>

                                <Box sx={{ maxWidth: { xs: '100%', md: '18rem' }, margin: { xs: '0', md: '2.45rem auto' }, 'button': { width: '100%', marginBottom: '.5rem' } }}>
                                    <ButtonRectangle name='CONTINUAR' onClick={() => setShowModalConfirm(true)} />
                                    <ButtonOutlined name='CANCELAR' onClick={() => setIsOpenModal(true)} />
                                </Box>
                            </Box>
                        </FadeAnimation>
                    </>
                }
            </Box>

            <ContentShopping>
                {customerPaymentForms ?
                    isPendingTicket ?
                        <Box sx={{ width: '100%', maxHeight: '100%', backgroundColor: '#EFF2F5' }} /> :
                        <ShoppingCart isWebView={true} />
                    :
                    <Box sx={{
                        width: '100%',
                        maxHeight: '100%',
                        backgroundColor: '#EFF2F5'
                    }}>
                        <Skeleton animation="wave" variant="rounded" height='25rem' sx={{ top: '23%', borderRadius: '10px' }} />
                    </Box>
                }
            </ContentShopping>

            <Modals open={showModalConfirm}>
                <Box sx={{ borderRadius: '.31rem', padding: { xs: '1.75rem 1.25rem 1.5rem', md: '3rem 2.2rem 1.5rem' }, textTransform: 'uppercase', width: { xs: 'calc(100vw - 2rem)', md: '25rem' } }}>
                    <Typography sx={{
                        backgroundColor: 'primary.main',
                        borderRadius: '2.5rem',
                        fontSize: { xs: '1.25rem', md: '1.5rem' },
                        color: 'white',
                        fontWeight: 700,
                        textAlign: 'center',
                        padding: '.5rem 1.3rem .3rem'
                    }}>
                        CONFIRME SUA COMPRA
                    </Typography>
                    <Box sx={{ paddingTop: '2.1rem' }}>
                        <Typography sx={styleTittle}>
                            FORMA DE PAGAMENTO:
                        </Typography>
                        <Typography sx={styleCase} marginTop='.8rem'>
                            {itemSelectedState?.PaymentFormTypeId === 22 ? 'Débito em conta' : 'Boleto eletrônico'}
                        </Typography>
                        <Box sx={{ paddingTop: '1.8rem' }}>
                            <Typography sx={styleTittle}>
                                SERVIÇO ADICIONAL CONTRATADO:
                            </Typography>

                            <Box sx={{
                                width: '100%',
                                position: 'relative',
                                maxHeight: { xs: '9rem', md: '10rem' },
                                overflowY: 'auto',
                                padding: '.8rem 0',
                                gap: '.8rem',
                                display: 'grid',
                                marginRight: dataProductCartAddServices?.productAdd?.length > 2 ? { xs: '-10px', md: '-22.3px' } : '0',
                                paddingRight: dataProductCartAddServices?.productAdd?.length > 2 ? '.52rem' : '0',
                                '::-webkit-scrollbar': {
                                    width: '.93rem',
                                },
                                '::-webkit-scrollbar-thumb': {
                                    background: '#8D9BB5',
                                    borderRadius: '.625rem'
                                }
                            }}>
                                {dataProductCartAddServices?.productAdd.map(({ nM_PRODUTO }, index) => (
                                    <Typography sx={styleCase} key={index}>
                                        {nM_PRODUTO}
                                    </Typography>
                                ))}
                            </Box>
                        </Box>

                        <Box sx={{ margin: '1.3rem auto 0', 'button': { width: '100%', marginBottom: '.9rem' } }}>
                            <ButtonRectangle name='FINALIZAR COMPRA' loadingBtn={isLoading} onClick={() => handlePostCreateOrderAddServicesState()} />
                            <ButtonOutlined name='VOLTAR' onClick={() => setShowModalConfirm(false)} />
                        </Box>
                    </Box>
                </Box>
            </Modals>

            <Modals open={showModalError}>
                <Box sx={{ width: { xs: 'calc(100vw - 2rem)', md: '26rem' }, textAlign: 'center' }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 2.56rem 1.25rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700}>
                            Central de Atendimento
                        </Typography>
                        <Typography fontSize='.875rem' lineHeight='17px' paddingTop='1rem'>
                            Fale conosco através dos números abaixo:
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: { xs: '1.25rem 2rem 2rem', md: '1.25rem 3.81rem 2rem' },
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        <Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography fontSize='.75rem' color='white' paddingBottom='.2rem'>
                                    São Paulo
                                </Typography>
                                <Typography fontSize='.75rem' color='white' paddingBottom='.2rem'>
                                    Digite a opção 1,2
                                </Typography>
                            </Box>
                            <LinkExtermal href="tel:1136169000">
                                (011) 3616-9000
                                <LocalPhoneOutlinedIcon />
                            </LinkExtermal>
                        </Box>
                        <Box>
                            <Typography fontSize='.75rem' color='white' paddingBottom='.2rem' textAlign='start'>
                                Outras localidades
                            </Typography>
                            <LinkExtermal href="tel:08007742000">
                                0800 774 2000
                                <LocalPhoneOutlinedIcon />
                            </LinkExtermal>
                        </Box>
                        <ButtonRectangle name='FECHAR' onClick={() => { setShowModalError(false); navigate(`${isWebView ? '/wb' : ''}/servicos-adicionais`); }} />
                    </Box>
                </Box>
            </Modals>

            <Modals open={isOpenModal}>
                <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '25.6rem' } }}>
                    <Box sx={{ padding: { xs: '1.78rem .9rem .59rem', md: '1.78rem 1.71rem 1.59rem' } }}>
                        <Typography fontSize='1.25rem' paddingBottom='1rem' fontWeight='700'>
                            Poxa, que pena que desistiu!
                        </Typography>
                        <Typography fontSize='1rem' lineHeight='1.27'>
                            Não se preocupe, o seu pedido <b>está guardado</b>, volte quando quiser e continue de onde parou.
                        </Typography>
                    </Box>
                    <Box sx={{ borderRadius: '0 0 8px 8px', backgroundColor: 'primary.main', padding: { xs: '2.17rem 2.6rem 2.5rem', md: '2.17rem 4.21rem 2.57rem' }, 'button': { width: '100%' } }}>
                        <ButtonRectangle
                            name='FECHAR'
                            onClick={() => navigate(`${isWebView ? '/wb' : ''}/servicos-adicionais`)} />
                    </Box>
                </Box>
            </Modals>
        </ParseWebView>
    );
}

export default Payment;